import { QueueWaitOfferOptionBuilder, QueueWaitOfferType } from '.';
var QueueWaitOfferOptionsBuilder = /** @class */ (function () {
    function QueueWaitOfferOptionsBuilder() {
        this.queueWaitOfferOptions = {
            callBackQueueWaitOffer: new QueueWaitOfferOptionBuilder().build(),
            transferQueueWaitOffer: new QueueWaitOfferOptionBuilder().build(),
            voiceMailWaitOffer: new QueueWaitOfferOptionBuilder().build(),
            activeQueueWaitOfferType: QueueWaitOfferType.CALLBACK
        };
    }
    QueueWaitOfferOptionsBuilder.prototype.withCallBackQueueWaitOffer = function (callBackQueueWaitOffer) {
        this.queueWaitOfferOptions.callBackQueueWaitOffer = callBackQueueWaitOffer;
        return this;
    };
    QueueWaitOfferOptionsBuilder.prototype.withTransferQueueWaitOffer = function (transferQueueWaitOffer) {
        this.queueWaitOfferOptions.transferQueueWaitOffer = transferQueueWaitOffer;
        return this;
    };
    QueueWaitOfferOptionsBuilder.prototype.withQueueWaitOfferType = function (queueWaitOfferType) {
        this.queueWaitOfferOptions.activeQueueWaitOfferType = queueWaitOfferType;
        return this;
    };
    QueueWaitOfferOptionsBuilder.prototype.build = function () {
        return this.queueWaitOfferOptions;
    };
    return QueueWaitOfferOptionsBuilder;
}());
export { QueueWaitOfferOptionsBuilder };
//# sourceMappingURL=queue-wait-offer-options.builder.js.map